"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormLeaveModal = void 0;
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
const FormLeaveModal = ({ active, onClose, onSkipWarning }) => {
    return (react_1.default.createElement(polaris_1.Modal, { onClose: onClose, open: active, primaryAction: {
            id: 'modal-leave-page-button',
            destructive: true,
            content: 'Leave page',
            onAction: onSkipWarning
        }, secondaryActions: [
            { id: 'modal-stay-button', content: 'Stay', onAction: onClose }
        ], title: 'Leave page with unsaved changes?' },
        react_1.default.createElement(polaris_1.Modal.Section, null,
            react_1.default.createElement(polaris_1.Text, { as: 'p' }, "Leaving this page will delete all unsaved changes."))));
};
exports.FormLeaveModal = FormLeaveModal;
